<h1 mat-dialog-title>Webcam</h1>
<div mat-dialog-content>
  <video #video autoplay></video>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onSave()">Take Snapshot</button>
  <div class="spacer"></div>
  <button mat-button mat-dialog-close>Cancel</button>
</div>
